// 订单共有
export default {
    // tab
    tab_all: "全部订单",
    tab_notPaid: "待付款",
    tab_notConsumed: "待使用",
    tab_completed: "已完成",
    tab_closed: "已关闭",
    fl_keyword: "输入搜索:",
    fp_keyword: "手机号码/订单编号",
    fl_startTime: "创建时间:",
    fp_startTime: "请选择开始时间",
    fp_endTime: "请选择结束时间",
    // 表格
    tl_id: "订单编号",
    tl_createTime: "创建时间",
    tl_name: "用户昵称",
    tl_mobile: "手机号码",
    tl_amount: "订单金额",
    tl_payModel: "支付方式",
    tl_channel: "渠道",
    tl_orderStatus: "订单状态",

    // 顶部
    heard_title: "创建订单",
    heard_btn: "返回",
    nav_title: "用户",
    fl_mobile: "手机号码:",
    fp_mobile: "请输入手机号码",
    form_number: "号",
    queryBtn: "确定",
    btn_pay: "支付",
    btn_addPrivate: "添加包场",
    btn_edit: "新增项目",
    btn_visitor: "游客购买",
    // 注册
    dt_nickName: "用户名称",
    dt_noUser: "未找到用户",
    content_title: "是否立即注册为新用户",
    dp_regName: "请输入昵称",
    em_regName: "请输入昵称",
    em_discountIpt: "请输入0-10之间的折扣",
    sm_reg: "注册成功",
    em_reg: "注册失败",
    // 查询
    em_queryUser: "请输入手机号码",
    em_queryUser1: "请输入手机号码或者号码",
    em_queryUser2: "请输入正确格式的手机号码",
    sm_getUser: "查询成功",
    // 支付
    payTip1: "支付成功",
    payTip2: "支付失败",
    payTip3: "支付结果未知",
    payStep1: "确定",
    payStep2: "重新支付",
    em_authCode: "付款码不能为空",
    em_payStatus: "订单已经支付成功,请勿重复提交",

    // 支付提示
    pay_amount: "支付金额：",
    pay_unit: "元",
    pay_way: "支付方式",

    // 支付方式选择
    dt_payLoding: "支付中",
    dl_needPay: "应收:",
    dl_payModel: "支付方式:",
    dp_payModel: "请选择支付方式",
    op_wechatpay: "微信支付",
    op_card: "会员卡",
    op_wallet: "钱包余额",
    op_cash: "现金",
    op_pos: "刷卡",
    op_other: "其他",
    op_alipay: "支付宝",
    dl_authCode: "付款码:",
    dp_authCode: "请使用扫码枪扫描付款码",
    btn_sendMail: "发送账单",
    dl_walletBalance: "卡中余额:",
    dl_paymentPassword: "密码:",
    dl_earnedRates: "实收:",
    dl_change: "找零:",

    // 创建-优惠信息
    table_title2: "优惠信息",
    fl_discountNum: "优惠金额:",
    fP_discountNum: "请选择",
    fl_discount: "折扣:",
    fp_discount: "请选择",
    countBox_desc: "优惠：",

    // 创建-支付信息
    pay_info_title: "支付信息",
    pay_info_orderCount: "订单合计",
    pay_Info_disountNum: "优惠",
    pay_info_payStatus: "待支付",
    pay_Info_operator: "操作",
    pay_info_btn: "支付",

    // 商品订单详情—订单状态
    order_status: "订单状态:",
    btn_closeOrder: "关闭订单",
    btn_orderMemo: "订单备注",

    // 订单详情状态 os:  order status
    os_paid: "已支付",
    os_nopay: "未支付",
    os_refunded: "已退款",
    os_canceled: "已核销",
    os_noCancel: "待核销",
    os_commented: "已评价",
    os_noComment: "待评价",

    // 订单基本信息 ob：order base
    ob_title: "基本信息",
    ob_orderNum: "订单编号",
    ob_userNum: "用户账号",
    ob_payWay: "支付方式",
    ob_channel: "渠道",
    ob_viewBtn: "查看",

    // 场次信息 si : spec info
    si_title: "场次信息",
    si_specStatus: "场次状态",
    si_ticketChange: "后台改签",
    si_refundByOperator: "人工退款",
    si_completed: "已核销",
    si_paid: "待核销",
    si_deny: "否",

    // 费用信息 ci : cost info
    ci_title: "费用信息",
    ci_shopTotal: "商品合计",
    ci_couponNum: "优惠",
    ci_orderTotal: "订单总金额",
    ci_dueNum: "应付款金额",

    // 操作信息  oi : operator info
    oi_title: "操作信息",
    tl_operator: "操作者",
    tl_opeTime: "操作时间",
    tl_orderStatu: "订单状态",
    tl_payStatus: "付款状态",
    tl_opeType: "操作类型",
    tl_desc: "备注",

    // 编辑选手弹出框
    dt_editPlayer: "车号&分组&选手",
    tl_kartName: "车型",
    tl_number: "票号",
    tl_group: "分组",
    tl_player: "选手",
    btn_enterSelf: "本人参赛"
};
